import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginResponse } from '../shared/models/external/login-response.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService, StaticSessionStorageKey, TokenSessionStorageKey } from '../shared/services/auth.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });
  loginFormSubmitted = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  resetPasswordUrl: string = environment.RESET_PASSWORD;

  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {};

  ngOnInit() {
    if(this.authService.isUserLoggedIn$) {
      this.router.navigate(['/manage-users']);
    }
  }

  onSubmit(){
    if(this.loginForm.valid) {
      this.loginFormSubmitted = true;
      this.authService.fetchStaticData();

      this.authService.login({
        username: this.loginForm.value['username']!,
        password: this.loginForm.value['password']!
      })
      .subscribe({
        next: (response: LoginResponse) => {
          sessionStorage.setItem(TokenSessionStorageKey, response.idtoken);

          this.authService.fetchStaticData().subscribe(staticDataResponse => {
            sessionStorage.setItem(StaticSessionStorageKey, JSON.stringify(staticDataResponse.body));
          });

          this.authService.isUserLoggedIn$.next(true);
          this.router.navigate(['/manage-users'])
        },
        error: (error: HttpErrorResponse) => {
          if(error.status == 400) {
            this.snackBar.open('Invalid Request - ' + error.error['message'], 'Dismiss', {
              duration: 5000,
            });
          }
          else if(error.status == 401 || error.status == 403){
            this.snackBar.open(error.error['message'], 'Dismiss', {
              duration: 5000,
            });
          }
          else {
            this.snackBar.open('Internal Error. Please contact the admin.', 'Dismiss', {
              duration: 5000,
            });
          }

          this.loginFormSubmitted = false;
        }
      });
    }
  }
}
